"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SegmentContentModel", {
    enumerable: true,
    get: function() {
        return SegmentContentModel;
    }
});
const _zod = require("zod");
const _metadatamodel = require("../metadata-model");
const SegmentContentModel = _metadatamodel.MetadataModel.merge(_zod.z.object({
    id: _zod.z.string({
        description: 'The unique identifier of the segment content.'
    }).ulid(),
    segmentId: _zod.z.string({
        description: 'The unique identifier of the segment.'
    }).ulid(),
    languageCode: _zod.z.string({
        description: 'The unique identifier of the language.'
    }),
    name: _zod.z.string({
        description: 'The name of the segment'
    }),
    description: _zod.z.string({
        description: 'The description of the segment'
    })
}));

//# sourceMappingURL=segment-content-model.js.map